import type { OrgPermission } from '../auth/orgPermissions';
import { checkOrgPermission } from '../auth/orgPermissions';
import { useActiveOrg } from './useActiveOrg';
import { useApiServices } from './useApiServices';

/**
 * Whether the signed-in user may do `permission` in the organization the app is acting in.
 *
 * The one gate for org-level actions, so the fail-closed rules in `checkOrgPermission` live in one
 * place: false until Clerk has loaded, false on an org restored from storage, false with no org.
 *
 * Record actions are deliberately not gated with this. Every member may create, edit and delete the
 * organization's records in this release, and the backend is the one enforcing it either way.
 */
export const useOrgPermission = (permission: OrgPermission): boolean => {
  const { hasOrgPermission } = useApiServices();
  const activeOrg = useActiveOrg();

  return checkOrgPermission(activeOrg, hasOrgPermission, permission);
};
